export const isEmpty = (str?: string): boolean => {
  return !str || str.trim() === '';
};
